import { User } from "types"

export default function isInternalUser(user?: User) {
  const groupId = user?.group?.id

  if (!groupId) {
    return false
  }

  return groupId === "00000" || groupId === "10100"
}
